import { render, staticRenderFns } from "./UploadActivity.vue?vue&type=template&id=fa8a2090&"
import script from "./UploadActivity.vue?vue&type=script&lang=js&"
export * from "./UploadActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports